/**
 * Wizard URL / deep-link helpers (city-based).
 * Extends window.WorkshopBookingWizardHelpers (defer after helpers.js).
 *
 * Canonical query: city, event_id, variant, wbw_step, date.
 * Legacy ?venue= is still read.
 */
(function (global) {
  'use strict';
  var H = global.WorkshopBookingWizardHelpers;
  if (!H) return;

  var extractNumericEventIdForUrl = H.extractNumericEventIdForUrl;
  var extractNumericVariantIdForUrl = H.extractNumericVariantIdForUrl;
  var extractNumericVenueRefForUrl = H.extractNumericVenueRefForUrl;
  var vQtyKey = H.vQtyKey;
  var venueNamesLooselyMatch = H.venueNamesLooselyMatch;
  var venueRefAliasKeys = H.venueRefAliasKeys;

  function bootStr(key) {
    try {
      var v = window[key];
      return v != null && String(v).trim() ? String(v).trim() : '';
    } catch (_) {
      return '';
    }
  }

  function readInitialVariantIdFromUrl() {
    if (window.__WB_INITIAL_VARIANT__ != null && String(window.__WB_INITIAL_VARIANT__).trim() !== '') {
      return vQtyKey(window.__WB_INITIAL_VARIANT__);
    }
    try {
      var v = new URLSearchParams(window.location.search).get('variant');
      return v && String(v).trim() ? vQtyKey(v) : '';
    } catch (_) {
      return '';
    }
  }

  function getEventIdFromUrl() {
    if (window.__WB_INITIAL_EVENT_ID__ != null && String(window.__WB_INITIAL_EVENT_ID__).trim() !== '') {
      return String(window.__WB_INITIAL_EVENT_ID__).trim();
    }
    try {
      return (new URLSearchParams(window.location.search).get('event_id') || '').trim();
    } catch (_) {
      return '';
    }
  }

  function getCityTokenFromUrl() {
    var boot = bootStr('__WB_INITIAL_CITY__');
    if (boot) return boot;
    try {
      var p = new URLSearchParams(window.location.search);
      return (p.get('city') || p.get('venue') || '').trim();
    } catch (_) {
      return '';
    }
  }

  function getVenueTokenFromUrl() {
    return getCityTokenFromUrl();
  }

  function getDateFromUrl() {
    var boot = bootStr('__WB_INITIAL_DATE__').slice(0, 10);
    if (boot) return boot;
    try {
      return (new URLSearchParams(window.location.search).get('date') || '').trim().slice(0, 10);
    } catch (_) {
      return '';
    }
  }

  function urlHasWizardDeepLink() {
    return !!(getCityTokenFromUrl() || getEventIdFromUrl() || getDateFromUrl());
  }

  function venueCardIsWaitlistOnly(card) {
    if (!card) return false;
    if (card.getAttribute('data-wb-waitlist-venue') === '1') return true;
    return !!(card._wbVenue && card._wbVenue._wbWaitlistVenue === true);
  }

  function getWbwStepFromUrl() {
    var boot = bootStr('__WB_INITIAL_WBW_STEP__').toLowerCase();
    try {
      var p = new URLSearchParams(window.location.search);
      var st = (p.get('wbw_step') || p.get('step') || boot || '').trim().toLowerCase();
      if (st === 'calendar' || st === 'time') return 'datetime';
      return st;
    } catch (_) {
      if (boot === 'calendar' || boot === 'time') return 'datetime';
      return boot;
    }
  }

  function clearWbwStepFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (!params.has('wbw_step')) return;
      params.delete('wbw_step');
      var qs = params.toString();
      var nextUrl =
        window.location.pathname + (qs ? '?' + qs : '') + (window.location.hash || '');
      history.replaceState(history.state, '', nextUrl);
    } catch (_) {}
  }

  function isVenueHandleToken(val) {
    var s = String(val == null ? '' : val).trim();
    return s.length > 0 && !/^\d+$/.test(s);
  }

  function cityUrlToken(venue) {
    if (!venue) return '';
    var h = String(venue.venue_handle || venue.handle || '').trim();
    if (h.indexOf('hub-city:') === 0) h = h.slice(9);
    if (h && !/^\d+$/.test(h)) return h;
    var city = String(venue.city_name || venue.city || '').trim();
    var state = String(venue.state || venue.state_code || '').trim();
    if (city && state) {
      return String(city + '-' + state)
        .toLowerCase()
        .replace(/&/g, 'and')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }
    if (city) {
      return city
        .toLowerCase()
        .replace(/&/g, 'and')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }
    return venueUrlToken(venue);
  }

  function venueUrlToken(venue) {
    if (!venue) return '';
    var cityTok = '';
    var h = String(venue.venue_handle || venue.handle || '').trim();
    if (h.indexOf('hub-city:') === 0) h = h.slice(9);
    if (h && !/^\d+$/.test(h)) cityTok = h;
    if (cityTok) return cityTok;
    var ref = extractNumericVenueRefForUrl(venue.venue_ref_id);
    if (ref) return ref;
    var evs = Array.isArray(venue.events) ? venue.events : [];
    for (var i = 0; i < evs.length; i++) {
      if (!evs[i]) continue;
      ref = extractNumericVenueRefForUrl(evs[i].venue_ref_id);
      if (ref) return ref;
    }
    for (var j = 0; j < evs.length; j++) {
      if (!evs[j]) continue;
      h = String(evs[j].venue_handle || '').trim();
      if (h) return h;
    }
    return '';
  }

  function venueHandleFromSlotRaw(raw) {
    if (!raw) return '';
    var h = String(raw.venue_handle || raw.city_handle || '').trim();
    if (h && !/^\d+$/.test(h)) return h;
    var ref = extractNumericVenueRefForUrl(raw.venue_ref_id);
    return ref || h || '';
  }

  function venueMatchesUrlToken(venue, token) {
    token = String(token || '').trim().toLowerCase();
    if (!token || !venue) return false;
    var cityTok = cityUrlToken(venue).toLowerCase();
    if (cityTok && cityTok === token) return true;
    if (String(venue.venue_handle || venue.handle || '').trim().toLowerCase() === token) return true;
    var evs = Array.isArray(venue.events) ? venue.events : [];
    for (var i = 0; i < evs.length; i++) {
      if (String((evs[i] && evs[i].venue_handle) || '').trim().toLowerCase() === token) return true;
    }
    var ref = extractNumericVenueRefForUrl(venue.venue_ref_id);
    if (ref && ref.toLowerCase() === token) return true;
    var nameFields = [venue.venue_name, venue.name, venue.city_name, venue.city];
    for (var ni = 0; ni < nameFields.length; ni++) {
      var n = String(nameFields[ni] || '').trim().toLowerCase();
      if (!n) continue;
      if (n === token) return true;
      if (venueNamesLooselyMatch(n, token)) return true;
    }
    var matched = false;
    venueRefAliasKeys(venue.venue_ref_id).forEach(function (k) {
      if (String(k).trim().toLowerCase() === token) matched = true;
    });
    return matched;
  }

  function updateWizardBookingUrl(patch) {
    if (!patch) return;
    var Flow = global.WorkshopCityFlow;
    if (Flow && typeof Flow.updateCityBookingUrl === 'function') {
      var next = {};
      if (Object.prototype.hasOwnProperty.call(patch, 'eventId')) next.eventId = patch.eventId;
      if (Object.prototype.hasOwnProperty.call(patch, 'variantId')) next.variantId = patch.variantId;
      if (Object.prototype.hasOwnProperty.call(patch, 'city')) next.city = patch.city;
      if (Object.prototype.hasOwnProperty.call(patch, 'venue')) next.city = patch.venue;
      if (Object.prototype.hasOwnProperty.call(patch, 'date')) next.date = patch.date;
      if (Object.prototype.hasOwnProperty.call(patch, 'step')) next.step = patch.step;
      Flow.updateCityBookingUrl(next);
      return;
    }
    try {
      var params = new URLSearchParams(window.location.search);
      if (Object.prototype.hasOwnProperty.call(patch, 'eventId')) {
        var eid = extractNumericEventIdForUrl(patch.eventId);
        if (eid) {
          window.__WB_STRIP_EVENT_ID_PARAM__ = false;
          params.set('event_id', eid);
          window.__WB_URL_EVENT_ID_NUMERIC__ = eid;
        } else {
          window.__WB_STRIP_EVENT_ID_PARAM__ = true;
          window.__WB_URL_EVENT_ID_NUMERIC__ = '';
          window.__WB_INITIAL_EVENT_ID__ = null;
          params.delete('event_id');
        }
      }
      if (Object.prototype.hasOwnProperty.call(patch, 'variantId')) {
        var vid = extractNumericVariantIdForUrl(patch.variantId);
        if (vid) {
          params.set('variant', vid);
          window.__WB_URL_VARIANT_NUMERIC__ = vid;
        } else {
          params.delete('variant');
          window.__WB_URL_VARIANT_NUMERIC__ = '';
        }
      }
      if (
        Object.prototype.hasOwnProperty.call(patch, 'city') ||
        Object.prototype.hasOwnProperty.call(patch, 'venue')
      ) {
        var vt = Object.prototype.hasOwnProperty.call(patch, 'city') ? patch.city : patch.venue;
        vt = String(vt == null ? '' : vt).trim();
        if (vt) {
          window.__WB_STRIP_CITY_PARAM__ = false;
          window.__WB_STRIP_VENUE_PARAM__ = false;
          params.set('city', vt);
          params.delete('venue');
          window.__WB_URL_CITY__ = vt;
        } else {
          window.__WB_STRIP_CITY_PARAM__ = true;
          window.__WB_STRIP_VENUE_PARAM__ = true;
          params.delete('city');
          params.delete('venue');
          window.__WB_URL_CITY__ = '';
          window.__WB_INITIAL_CITY__ = null;
        }
      }
      if (Object.prototype.hasOwnProperty.call(patch, 'date')) {
        var d = String(patch.date || '')
          .trim()
          .slice(0, 10);
        if (/^\d{4}-\d{2}-\d{2}$/.test(d)) {
          window.__WB_STRIP_DATE_PARAM__ = false;
          params.set('date', d);
        } else {
          window.__WB_STRIP_DATE_PARAM__ = true;
          params.delete('date');
        }
      }
      if (Object.prototype.hasOwnProperty.call(patch, 'step')) {
        var st = String(patch.step || '').trim().toLowerCase();
        if (st === 'calendar' || st === 'time') st = 'datetime';
        if (st === 'datetime' || st === 'variants') {
          window.__WB_STRIP_STEP_PARAM__ = false;
          params.set('wbw_step', st);
        } else {
          window.__WB_STRIP_STEP_PARAM__ = true;
          params.delete('wbw_step');
        }
      }
      var qs = params.toString();
      var nextUrl =
        window.location.pathname + (qs ? '?' + qs : '') + (window.location.hash || '');
      history.replaceState(history.state, '', nextUrl);
    } catch (_) {}
  }
  H.clearWbwStepFromUrl = clearWbwStepFromUrl;
  H.cityUrlToken = cityUrlToken;
  H.getCityTokenFromUrl = getCityTokenFromUrl;
  H.getDateFromUrl = getDateFromUrl;
  H.getEventIdFromUrl = getEventIdFromUrl;
  H.getVenueTokenFromUrl = getVenueTokenFromUrl;
  H.getWbwStepFromUrl = getWbwStepFromUrl;
  H.isVenueHandleToken = isVenueHandleToken;
  H.readInitialVariantIdFromUrl = readInitialVariantIdFromUrl;
  H.updateWizardBookingUrl = updateWizardBookingUrl;
  H.urlHasWizardDeepLink = urlHasWizardDeepLink;
  H.venueCardIsWaitlistOnly = venueCardIsWaitlistOnly;
  H.venueHandleFromSlotRaw = venueHandleFromSlotRaw;
  H.venueMatchesUrlToken = venueMatchesUrlToken;
  H.venueUrlToken = venueUrlToken;
})(typeof window !== "undefined" ? window : this);
